<template>
    <el-dialog
            title="修改快递单号"
            :visible="true"
            :append-to-body=true
            width="30%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
            <el-form-item label="快递单号:">
                <el-input v-model="form.code" clearable placholder="请输入快递单号"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="save()">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "deliver",
        data(){
            return {
            form:{
                code:''
                }
            }
        },
        props:{
            pushData:{
                type:Object,
                default:function(){
                    return;
                }
            }

        },
        methods:{
            save(){
                let url = '/returngoods/' + this.pushData.return_goods_sn +'/express'
                this.$patch('logistics',url, {
                    lang:'',
                    _method:'PATCH',
                    returngoods:this.pushData.return_goods_sn,
                    express_sn:this.form.code
                }).then(res => {
                    if(res.message =='操作成功'){
                        this.$message({
                            type: 'success',
                            message: '修改成功!'
                        });
                        this.$emit('refresh');
                        this.$emit('handleClose');
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            handleClose(){
                this.$emit('handleClose');
            }
        },
        created() {
            this.form.code =  this.pushData.express_sn;
        }
    }
</script>

<style scoped>

</style>